<template>
  <ApiButton
    :call-fn="toContract"
    :height="height"
    :classes="[...classes]"
    :disabled="!canContract"
    :button-text="buttonText"
    loading-text="계약서를 불러오고 있습니다"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  props: {
    // loan
    uuid: {
      type: String,
      required: true,
    },
    classes: {
      type: Array,
      default() {
        return ['font--m-3']
      },
    },
    height: {
      type: String,
      default: '52',
    },
  },
  data() {
    return {
      loan: null,
      loansRequest: null,
      contract: null,
      investingAmount: null,
    }
  },
  components: { ApiButton: () => import('../loans-request/ApiButton.vue') },
  async created() {
    // loan으로 loansRequest 조회
    const { data } = await defaultApi.getLoansRequestByLoan(this.uuid)
    this.loansRequest = data

    const [loan, agreements, investingAmount] = await Promise.all([
      this.getLoansDetail(this.uuid),
      this.getContractAgreements(),
      this.getInvestingAmount(this.uuid),
    ])
    // 대출
    this.loan = loan

    // 모집금액
    this.investingAmount = investingAmount || 0

    // 계약서
    const contract = agreements.find(
      (item) =>
        item.term.code === 'LIMIT_TRANSACTION' &&
        item.isAgreed === true &&
        item.offer?.uuid === loan.offer.uuid,
    )
    this.contract = contract
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('contract', { contractCurrent: 'current' }),
    buttonText() {
      if (this.loan?.status === 'investing' && !this.canContract) {
        return '투자금을 모집중입니다'
      }

      if (this.loan?.status === 'executing') {
        return '대출금 송금 준비 중'
      }

      if (this.contractCurrent?.status !== 'started') {
        return '계약서 작성불가'
      }

      return '계약서 작성하기'
    },
    canContract() {
      if (
        !this.loan ||
        !['investing', 'invested'].includes(this.loan.status) ||
        this.investingAmount < 1 ||
        this.me.store.isClosed ||
        this.contractCurrent?.status !== 'started'
      ) {
        return false
      }

      const now = this.$moment()
      const start = this.$moment(this.loan.contractStartTime)
      const end = this.$moment(this.loan.contractEndTime)
      // loansRequest가 존재하고 loansRequest가 approved가 아니면 계약서 작성불가
      if (this.loansRequest && this.loansRequest.status !== 'approve') {
        return false
      }
      // 우리동네 크라우드 상품은 금액 모이면 일찍 계약서 작성 가능
      if (
        ['woori_crowd'].includes(this.loan?.offer?.loanType) &&
        this.loan.amount - this.investingAmount < 5000
      ) {
        return now.isBefore(end)
      }

      return now.isSameOrAfter(start) && now.isBefore(end)
    },
  },
  methods: {
    ...mapActions('loan', [
      'getLoansDetail',
      'getInvestingAmount',
      'closeLoan',
      'getLoansByOngoing',
    ]),
    ...mapActions('agreement', ['getContractAgreements']),

    async toContract() {
      if (!this.canContract) {
        return
      }

      // 모집 마감 시킨 후 이동
      await this.closeLoan(this.loan.uuid)

      // 대출 상태 업데이트
      await this.getLoansByOngoing()

      await this.$router.push({
        name: 'loan/contract',
        params: { uuid: this.loan.uuid },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
